import { Point } from 'pixi.js';
import { IReelConfig } from '../../core/reel/IData/IReelData';
import { ReelEngineManager } from '../../core/reel/ReelEngineManager';
import { ArrayHelper } from '../../core/utils/ArrayHelper';
import { IDimOrientation, LayoutDimData, ResizeHelper } from '../../core/utils/ResizeHelper';
import { ReelGameData } from '../server/data/GameDataModels';
import { BeheadedEngineController } from './BeheadedEngineController';
import { BeheadedSymbol } from './symbol/BeheadedSymbol';

export class BeheadedEngineManager extends ReelEngineManager {
    private containerSwirlAnimation: PIXI.Container;

    protected static readonly reelDim: IDimOrientation = {
        landscape: {
            scale: new Point(1, 1),
            position: new Point(80, 120),
        },
        portrait: {
            scale: new Point(1, 1),
            position: new Point(80, 120),
        },
    };

    private maskObj: PIXI.Graphics;

    constructor(reelAmount: number, config: IReelConfig, initData: any, juri_time_calc: (value: number) => number) {
        super(reelAmount, config, initData, juri_time_calc);
    }

    protected init(amount: number, initData: any): void {
        this.sortableChildren = true;

        this.containerSwirlAnimation = new PIXI.Container();
        this.addChild(this.containerSwirlAnimation);

        super.init(amount, initData);

        this.maskObj = this.createGraphic(undefined, undefined);
        this.maskObj.name = 'mask';
        this.maskObj.visible = false;
        this.maskObj.width += 200;
        this.maskObj.position.x = -100;
        this.applyMask(true);
    }

    protected createGraphic(color: number = 0x000000, alpha: number = 1): PIXI.Graphics {
        const w: number = ArrayHelper.fetchArrTypeValue(this.reelConfig.DIM.WIDTH, 0) * this.AllReels.length;
        const h: number = ArrayHelper.fetchArrTypeValue(this.reelConfig.DIM.HEIGHT, 0);
        const hOffset: number = h / this.reelConfig.WINDOW_AMOUNT;
        const ms: PIXI.Graphics = new PIXI.Graphics();
        ms.beginFill(color, alpha);
        ms.drawRect(0, -(hOffset / 2 + 50), w, h + 100);
        ms.endFill();
        this.addChild(ms);
        return ms;
    }

    public get dim(): LayoutDimData {
        return BeheadedEngineManager.dim;
    }

    public static get dim(): LayoutDimData {
        return ResizeHelper.calcDim(this.reelDim);
    }

    public static get allCutIndexes(): number[] {
        return BeheadedEngineManager.AllReels.map((rc) => rc.currentCutIndx).filter((v) => v != 5 && v != -1);
    }

    public static getReel(ID: number): BeheadedEngineController {
        return <BeheadedEngineController>super.getReel(ID);
    }

    public static get AllReels(): BeheadedEngineController[] {
        return <BeheadedEngineController[]>this._reels;
    }

    public get AllReels(): BeheadedEngineController[] {
        return <BeheadedEngineController[]>ReelEngineManager.AllReels;
    }

    public getPosition(reelId: number, symbolId: number): PIXI.Point {
        return new PIXI.Point(
            this.position.x + this.AllReels[reelId].position.x + this.AllReels[symbolId].getSymbol(symbolId)!.position.x,
            this.position.y + this.AllReels[reelId].position.y + this.AllReels[symbolId].getSymbol(symbolId)!.position.y
        );
    }

    public static RSWindow(func: (rc: BeheadedEngineController, sym: BeheadedSymbol) => void): void {
        this.RAll((rc: BeheadedEngineController) => {
            for (let symID: number = 0; symID < rc.AllWindowSymbols.length; symID++) func(rc, rc.AllWindowSymbols[symID]);
        });
    }

    public static RSAll(func: (rc: BeheadedEngineController, sym: BeheadedSymbol) => void): void {
        this.RAll((rc: BeheadedEngineController) => {
            for (let row: number = 0; row < rc.AllSymbols.length; row++) func(rc, rc.AllSymbols[row]);
        });
    }

    public static RAll(func: (rc: BeheadedEngineController) => void): void {
        for (let reel: number = 0; reel < this.AllReels.length; reel++) {
            func(this.AllReels[reel]);
        }
    }

    protected createReel(ID: number, initData: ReelGameData): BeheadedEngineController {
        return new BeheadedEngineController(ID, this.reelConfig, initData);
    }

    onResize(): void {
        super.onResize();
        const toScale:number = ResizeHelper.isIPadd ? 0.9 : 1;
        if(this.parent)this.parent.scale.set(toScale);
    }

    applyMask(val: boolean): void {
        this.mask = val ? this.maskObj : undefined!;
        this.maskObj.visible = val;
    }

    public addSwirl(swirl: PIXI.DisplayObject) {
        this.containerSwirlAnimation.addChild(swirl);
    }

    public removeSwirl(swirl: PIXI.DisplayObject) {
        this.containerSwirlAnimation.removeChild(swirl);
    }
}
